import { gql } from "apollo-boost";

export const CREATE_BANK = gql`
  mutation Mutation($data: BankInput!) {
    createBank(data: $data) {
      id
    }
  }
`;

export const DELETE_BANK = gql`
  mutation DeleteBank($where: BankWhereInputOne!) {
    deleteBank(where: $where) {
      id
    }
  }
`;

export const UPDATE_BANK = gql `
mutation Mutation($where: BankWhereInputOne!, $data: BankInput!) {
    updateBank(where: $where, data: $data) {
      id
    }
  }
`
